import { ref, onMounted, onUnmounted } from 'vue'

export function useMobile() {
  const isMobile = ref(false)
  const mobileWidth = 768

  const checkMobile = () => {
    const rect = document.body.getBoundingClientRect()
    isMobile.value = rect.width - 1 < mobileWidth
  }

  onMounted(() => {
    checkMobile()
    window.addEventListener('resize', checkMobile)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
  })

  return {
    isMobile
  }
}
